export class Constants {
  static readonly DATE_FMT = 'dd/MMM/yyyy';
  static readonly DATE_TIME_FMT = `${Constants.DATE_FMT} hh:mm:ss`;
  static readonly DEFALUTPAGE ='login'
}
export class AppModuleList {
  static readonly  Module_ExcelReports: string = "0CC8937C-BD62-438A-B030-480D029D54B4"; //Reports
  static readonly Module_NurseProfile: string = "2DBB0D61-A67E-45B3-A3E9-9575B034E98F";// NurseProfile


  static readonly Module_NCS_UserProfile: string = "053C31FD-A029-4109-9E47-A1D5153907AD"; //Module_NCS_UserProfile
  //
  static readonly Module_NCS_UserManagement: string = "88941336-8698-484D-9ECB-A8C51EEE01EA"; //Module_NCS_UserManagement
  //
  static readonly Module_NCS_Account: string = "85B13DCC-811C-4102-9210-CF1421EC2176"; //Module_NCS_Account
  //
  static readonly Module_NCS_DashBoard: string = "445EFF5A-8193-41CC-8221-7A2F0B12F1E1"; //NCS_DashBoard
  //
  static readonly Module_NCS_SystemAdmin: string = "07AA61A9-9556-4C33-B2F4-346EDCC1E21A"; //NCS_SystemAdmin

  //
  static readonly Module_NCS_DocumentVerification: string = "7DB3A62C-5698-4428-B749-D7D9058E51F4"; //NCS_DocumentVerification

  static readonly Module_NCS_HospitalSettings: string = "8E70F78F-0A70-477D-9A73-9C6191A71EDF"; //NCS_HospitalSettings

  static readonly Module_NCS_RegistryRecruitmentSetting: string = "870043D1-794F-4CCE-8DBE-EC768E10E8E6"; //NCS_RegistryRecruitmentSetting
}


export class AppFeaturesList {

  
  //
  static readonly Feature_ExcelReports_ActorDetailInfo: string = "04A57B10-5ED9-47EE-A81D-DEDAAB5354A7";

  //
  static readonly Feature_NurseProfile_PersonalInfo: string = "6A2B9109-0B8C-4E15-8D2A-AD6D8584D6B4";
  static readonly Feature_NurseProfile_ContactInfo: string = "DC2F4D17-D992-408D-9ED1-87A3A394501F";
  static readonly Feature_NurseProfile_ProfileSummary: string = "DF14863A-32D1-4B9E-92D7-28DDBB6AFA9C";
  static readonly Feature_NurseProfile_JobPreferences: string = "9CB10E35-9994-4CDD-98C8-119333B1E20A";
  static readonly Feature_NurseProfile_Education: string = "BBFC5EF9-838C-4097-9DD4-7CA1F3DA16AB";
  static readonly Feature_NurseProfile_EmploymentHistory: string = "D8FC7C88-3C49-4066-8421-CA24C6115ACB";
  static readonly Feature_NurseProfile_References: string = "64EC58AE-5C45-496E-86C1-247191FAA28C";
  static readonly Feature_NurseProfile_Identities: string = "92F8F884-38E9-4835-83CE-13F2D942D65A";
  static readonly Feature_NurseProfile_Certifications: string = "D03EBA0D-B11C-4A90-80A0-8AB576DC66E4";
  static readonly Feature_NurseProfile_MedicalFitness: string = "11CA6BB9-37D8-4E96-9EF3-45EAAD121562";

  static readonly Feature_NurseProfile_ProfileImage: string = "9DFDE461-4CB4-4F6D-BB47-468FECA4173E";
  static readonly Feature_NurseProfile_Legalinfo: string = "7DC92AF8-93B0-4A8B-87F8-1C9C6C8B55D9";
  //


  //
  static readonly Feature_NCS_UserManagement_Employees: string = "24EFAEFA-EA08-489C-9583-745B64B88A71";



  static readonly Feature_NCS_Account_AccountProfile: string = "766E39A3-96F0-409C-874D-B5FB642A7468";


  static readonly Feature_UserProfile_NCS_UserProfile: string = "0657811E-8446-417A-AC0B-FC376CE86D20";
  static readonly Feature_UserProfile_NCS_UserImage: string = "FAA776F2-01FC-44B9-B900-F4A16CB12F9D";

  //
  static readonly Feature_AdminDashBoard_NCS_DashBoard: string = "517E95C5-420F-4CD7-BF43-8FDD43A4F496";
  static readonly Feature_UserDashBoard_NCS_DashBoard: string = "4A12D1DE-6964-4C21-9D71-E2ACFDAF9A47";

  //

  static readonly Feature_SystemAdminDashBoard_NCS_SystemAdmin: string = "FABD6193-E7E1-4ACC-9D57-3EC703D8641D";
  static readonly Feature_CompanyProfile_NCS_SystemAdmin: string = "C9EA8EF9-CC8F-472E-B664-0EE84CFA4BE8";
  static readonly Feature_Facilities_NCS_SystemAdmin: string = "A53D6235-4499-4ABD-B4A9-BF3A8DE6874F";
  static readonly Feature_NCS_SystemAdmin_CodeType: string = "95EA92F4-1157-4CEC-9DAF-038FD3B626BE";
  static readonly Feature_NCS_SystemAdmin_RoleManagement: string = "B77FA166-C084-4ADE-B7DA-D4A5A4A6B609";
  static readonly Feature_NCS_SystemAdmin_Reports: string = "24EA6FFB-1CAD-459A-AA03-39044CBCB6D4";

  static readonly Feature_NCS_SystemAdmin_FormDesign: string = "88640D7E-89F3-45D8-B3C8-4E83F0708EF8";
  static readonly Feature_NCS_SystemAdmin_CredentialMaster: string = "F31B8E0E-210A-42A5-B794-BD9977CCFC24";
  static readonly Feature_NCS_SystemAdmin_RoleDutyMaster: string = "4ED9B590-F095-4216-AC32-812349ACA9A7";
  static readonly Feature_NCS_SystemAdmin_CredentialConfig: string = "5E6EB5E4-F74E-477E-8B46-2E5070E51B17";
  static readonly Feature_NCS_SystemAdmin_DocRenewalConfig: string = "43C510C4-DCF1-46F8-A17D-0B919CA630FD";

  //
  static readonly Feature_DocVerification_CanViewDocuments: string = "B32973E3-9C32-495E-8E91-8FBBC2514FF7";
  static readonly Feature_DocVerification_CanUpdateDocVerificationTrack: string = "06120389-8927-4AD6-9A80-22E1AC9895FA";
  static readonly Feature_DocVerification_CanInciateDocVerification: string = "3FF9A4A8-F230-400F-B256-D091D30D4AB8";
  static readonly Feature_DocVerification_CanCloseDocVerification: string = "C318F707-1319-4DE9-843A-7CF9D6444F90";
  static readonly Feature_DocVerification_CanReOpenDocVerification: string = "15660AB0-280C-448F-A932-E16BC19C15DB";
  static readonly Feature_DocVerification_CanAssignDocVerification: string = "06DBB9F2-1671-4153-A3DD-F235DD967501";
  static readonly Feature_DocVerification_CanShowDocVerification: string = "8A5AA196-28AF-465C-958B-DB94A0C8EC86";
  static readonly Feature_DocVerification_NurseProfiles: string = "E56E26DF-8C5C-4688-852A-D844BB9190E9";


  //
  static readonly Feature_AdminDashBoard_HospitalAdminDashBoard: string = "6AA3A261-9453-4E09-A815-D7839388184E";
  static readonly Feature_UserDashBoard_NCS_HospitalUserDashBoard: string = "6DFD87D0-14DC-4005-A1D1-768A7924314A";

  static readonly Feature_NCS_HospitalSettings_HospitalMasterSettings: string = "2550C8AC-BA9A-4F85-80A5-911243D52904";
  static readonly Feature_NCS_HospitalSettings_ShiftAllocation: string = "7CF5C8B0-AD56-4B1F-953B-18AD093B34B8";
  static readonly Feature_NCS_HospitalSettings_ResourceIdenification: string = "5AE92F15-9224-45FD-92EF-DD04EB2E8F9E";
  static readonly Feature_NCS_HospitalSettings_JobOrders: string = "C46BCFD3-3AD2-464E-9CC6-63ECCF8F2A43";
  static readonly Feature_NCS_HospitalSettings_Applicants: string = "F928C403-3119-44C8-95CD-E2CEF551A2A2";
  static readonly Feature_NCS_HospitalSettings_Contracts: string = "5AC72E91-29F6-4BF8-89AE-AB9EA0CD682F";
  static readonly Feature_NCS_HospitalSettings_StaffAllocation: string = "3590E799-FE9A-4746-9571-EDCAECD2AC0C";
  static readonly Feature_NCS_HospitalSettings_StaffAttendance: string = "62D9FD1B-0CD4-4C67-9BBC-7C9724B28958";

  //
  static readonly Feature_NCS_RegistryRecruitmentSetting_JobOrders: string = "D403FAFE-6BCA-4F77-8935-E084883BD6F7";
  static readonly Feature_NCS_RegistryRecruitmentSetting_JobApplicants: string = "9E28BDD1-47A8-4DED-8EC0-8B3AB6D953BA";
  static readonly Feature_NCS_RegistryRecruitmentSetting_RegistryContracts: string = "C9A2293B-8899-4508-9AD1-B1574A8B7C55";
}
